module.exports = __webpack_public_path__ + "images/standard-8add21aa5486275cd8b88acc960283d1.jpg";